// Analytics is OFF until the visitor accepts it in the consent banner.
// Nothing loads at all unless REACT_APP_POSTHOG_KEY is set at build time.
const KEY = process.env.REACT_APP_POSTHOG_KEY || "";
const HOST = process.env.REACT_APP_POSTHOG_HOST || "https://us.i.posthog.com";
const STORE = "vlx_consent_v1"; // "granted" | "denied"

// Valuelix's own anonymous visit counts (stored in our database) are always available,
// so the consent banner is always shown; PostHog loads only if a key is set.
export const analyticsConfigured = () => true;

export function getConsent() {
  try { return localStorage.getItem(STORE); } catch { return null; }
}

function loadPostHog() {
  if (!KEY || window.posthog?.__loaded || window.__vlxPosthogLoading) return;
  window.__vlxPosthogLoading = true;
  const s = document.createElement("script");
  s.async = true;
  s.crossOrigin = "anonymous";
  s.src = HOST.replace(".i.posthog.com", "-assets.i.posthog.com") + "/static/array.full.js";
  s.onload = () => {
    try {
      window.posthog.init(KEY, {
        api_host: HOST,
        person_profiles: "identified_only",
        disable_session_recording: true,
        persistence: "localStorage+cookie",
      });
    } catch { /* ignore */ }
  };
  document.head.appendChild(s);
}

export function setConsent(value) {
  try { localStorage.setItem(STORE, value); } catch { /* storage blocked */ }
  if (value === "granted") loadPostHog();
  else if (window.posthog?.opt_out_capturing) {
    try { window.posthog.opt_out_capturing(); window.posthog.reset(); } catch { /* ignore */ }
  }
  window.dispatchEvent(new Event("vlx-consent"));
}

// Called once at startup: load analytics only for visitors who already accepted.
export function initAnalytics() {
  if (getConsent() === "granted") loadPostHog();
}

export function openConsentSettings() {
  window.dispatchEvent(new Event("vlx-consent-open"));
}

// Anonymous event for the owner's dashboard. Sent ONLY after the visitor accepted analytics.
export function track(type, data = {}) {
  if (getConsent() !== "granted") return;
  try {
    // lazy import keeps this file free of the API client for the first paint
    import("@/lib/api").then(({ default: api }) => api.post("/events", { type, ...data }).catch(() => {}));
  } catch { /* ignore */ }
}

// Report browser errors (message, page, stack only — no personal data) so bugs show up in /admin -> Errors.
let sentErrors = 0;
export function initErrorReporting() {
  const send = (message, stack) => {
    if (sentErrors >= 5 || !message) return;
    sentErrors += 1;
    import("@/lib/api").then(({ default: api }) => api.post("/client-error", {
      message: String(message).slice(0, 500), path: window.location.pathname.slice(0, 200), stack: stack ? String(stack).slice(0, 2000) : null,
    }).catch(() => {}));
  };
  window.addEventListener("error", (e) => { if (e.error || e.message) send(e.message, e.error && e.error.stack); });
  window.addEventListener("unhandledrejection", (e) => {
    const r = e.reason;
    if (r && r.isAxiosError) return; // API errors are shown to the user already
    send(r && (r.message || String(r)), r && r.stack);
  });
}
